import { Grid, GridProps } from '@mui/material';
import { ourUomType } from '@petconsole/pure-shared';
import OurUom, { OurUomProps } from './OurUom';

interface OurSelectLengthUomProps extends Omit<OurUomProps, 'type'> {
  grid?: boolean;
  gridProps?: GridProps;
}

const OurSelectLengthUom = ({ grid, gridProps, label = 'Length UOM', ...rest }: OurSelectLengthUomProps) => {
  const ourUomProps = { type: ourUomType.Length, label: label, ...rest };

  if (!grid && !gridProps) return <OurUom {...ourUomProps} />;

  return (
    <Grid item xs={12} {...gridProps}>
      <OurUom {...ourUomProps} />
    </Grid>
  );
};

OurSelectLengthUom.whyDidYouRender = true;

export default OurSelectLengthUom;
